// @flow
import * as cc from 'common/constants';

import createReducer from './createReducer';
import createReducerPart from './createReducerPart';

type MapActionTypes = {
  REQUESTED: string | string[],
  SUCCESS: string | string[],
  ERROR: string | string[],
};

type State = cc.FetchStatus;

const initialState: State = cc.FETCH_STATUS.PENDING;

export function createFetchStatusReducer(mapToTypes: MapActionTypes) {
  return createReducer(initialState, {
    ...createReducerPart(mapToTypes.REQUESTED, () => cc.FETCH_STATUS.LOADING),
    ...createReducerPart(mapToTypes.SUCCESS, () => cc.FETCH_STATUS.LOADED),
    ...createReducerPart(mapToTypes.ERROR, () => cc.FETCH_STATUS.ERROR),
  });
}

export default createFetchStatusReducer;



// WEBPACK FOOTER //
// ./src/store/helpers/createFetchStatusReducer.js